module.exports = __webpack_public_path__ + "media/images/header_sp-20e3e9cb1d5dfb586b52cc4ae83d7193.svg";